<template>
  <div class="permission-matrix">
    <loading
      :active.sync="isLoading"
      :is-full-page="fullPage"
      background-color="#f3f3f3"
      :opacity="0.8"
      loader="bars"
    ></loading>
    <!-- Role tabs -->
    <div class="roles-tabs mb-6">
      <button
        v-for="role in roles"
        :key="role"
        @click="currentRole = role"
        :class="['role-tab', { active: currentRole === role }]"
      >
        {{ role }}
      </button>

      <button
        @click="$emit('role-permissions', matrix, currentRole)"
        class="btn btn-primary ml-auto save-btn"
      >
        Save Permissions
      </button>
    </div>

    <!-- Permissions table -->
    <div class="permissions-table">
      <div class="table-header">
        <div class="feature-col">Features</div>
        <div class="permission-cols">
          <div>Add/Edit</div>
          <div>View</div>
          <div>Export</div>
        </div>
      </div>

      <div
        v-for="(permissions, feature) in features"
        :key="feature"
        class="table-row"
      >
        <div class="feature-name capitalize">{{ feature }}</div>
        <div class="permission-checkboxes">
          <label v-for="permission in permissionKeys" :key="permission">
            <input
              type="checkbox"
              v-model="matrix[currentRole][feature][permission]"
              :disabled="currentRole === 'Admin'"
            />
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Loading from "vue-loading-overlay";

export default {
  name: "PermissionMatrix",
  components: {
    Loading,
  },
  data() {
    return {
      currentRole: "Admin",
      roles: ["Admin", "Manager", "Staff"],
      permissionKeys: ["addOrEdit", "view", "export"],
      matrix: {
        Admin: {},
        Manager: {},
        Staff: {},
      },
      permissions: {},
      isLoading: false,
      fullPage: true,
    };
  },
  computed: {
    ...mapGetters(["userPermissions", "currentModulePermissions"]),

    features() {
      return Object.entries(this.userPermissions).reduce(
        (acc, [feature, permissions]) => {
          acc[feature] = {
            addOrEdit: permissions?.addOrEdit || false,
            view: permissions.view || false,
            export: permissions.export || false,
          };
          return acc;
        },
        {}
      );
    },
  },
  methods: {
    ...mapActions(["getRolePerm"]),
    initializeMatrix() {
      const roles = this.roles.reduce((roleAcc, role) => {
        roleAcc[role] = Object.entries(this.features).reduce(
          (featureAcc, [feature, permissions]) => {
            featureAcc[feature] = { ...permissions };
            return featureAcc;
          },
          {}
        );
        return roleAcc;
      }, {});

      this.matrix = roles;
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.initializeMatrix();
    });
  },
  watch: {
    // matrix: {
    //   handler() {
    //     console.log(this.matrix, "Matrix");
    //   },
    //   deep: true,
    // },
    currentModulePermissions: {
      handler() {
        this.matrix[this.currentRole] = this.currentModulePermissions;
      },
      deep: true,
    },
    currentRole() {
      this.isLoading = true;
      this.getRolePerm(this.currentRole.toLowerCase()).then(() => {
        this.isLoading = false;
      }).catch((error) => {
        console.error("Error getting role permissions:", error);
        this.isLoading = false;
      });
    },
  },
};
</script>

<style scoped>
.permission-matrix {
  background: white;
  border-radius: 8px;
  padding: 24px;
}

.roles-tabs {
  display: flex;
  gap: 24px;
  border-bottom: 1px solid #eee;
  width: 100%;
}

.role-tab {
  padding: 8px 16px;
  border: none;
  background: none;
  cursor: pointer;
  color: #666;
  position: relative;
}

.role-tab.active {
  color: #213e7a;
  font-weight: 600;
}

.role-tab.active::after {
  content: "";
  position: absolute;
  bottom: -1px;
  left: 0;
  right: 0;
  height: 2px;
  background: #213e7a;
}

.permissions-table {
  margin-top: 24px;
}

.table-header {
  display: flex;
  padding: 12px 0;
  font-weight: 600;
  color: #374151;
}

.feature-col {
  flex: 1;
}

.permission-cols {
  display: flex;
  gap: 48px;
  width: 300px;
  justify-content: space-between;
}

.table-row {
  display: flex;
  padding: 12px 0;
  align-items: center;
  border-bottom: 1px solid #f3f4f6;
}

.feature-name {
  flex: 1;
  color: #374151;
  text-transform: capitalize;
}

.permission-checkboxes {
  display: flex;
  gap: 48px;
  width: 300px;
  justify-content: space-between;
}

input[type="checkbox"] {
  width: 16px;
  height: 16px;
  border: 2px solid #d1d5db;
  border-radius: 4px;
  cursor: pointer;
  accent-color: transparent;
}

input[type="checkbox"]:disabled {
  background-color: #f3f4f6;
  cursor: not-allowed;
}

input[type="checkbox"]:checked {
  background-color: #213e7a;
  border-color: #213e7a;
}
button:focus {
  outline: none;
}
.save-btn {
  font-size: 14px;
    padding: 4px 20px !important;
    height: fit-content;
}
</style>
